import { Stack } from '@ltvco/refresh-lib/theme';
import { useEffect } from 'react';

import { VehicleReview } from 'components/VehicleReview/VehicleReview';

export function VehicleReviewPage() {
  useEffect(() => {
    document.title = 'Vehicle Review - Bumper';
  }, []);

  return (
    <Stack pt={1.5}>
      <VehicleReview />
    </Stack>
  );
}
